export function transformChatData(data) {
  const transformed = [];

  data.forEach((item, index) => {
    if (item.question) {
      transformed.push({
        user: "user",
        message: item.question,
        id: item.id || `${Date.now()}-${index}`,
      });
    }
    if (item.answer) {
      transformed.push({
        user: "bot",
        message: item.answer,
        question: item.question,
        timestamp: item.timestamp,
      });
    }
  });

  return transformed;
}
